import {
  SELECT_DAY,
  SET_DURATION,
  SET_TIME_RANGE,
  SELECT_SERVICE,
  SELECT_DAY_AND_SERVICE
} from '../actions/filterActions';
// import {
//   CUSTOMER_SUBSCRIPTION_SET,
//   CUSTOMER_SUBSCRIPTION_UPDATED
// } from '../actions/customerSubscriptionActions';
import { USER_LOGOUT } from '../actions/userActions';

const INITIAL_STATE = {
  durationInMinutes: 30,
  selectedDay: null,
  selectedService: {
    id: null,
    category: null,
    language: null
  },
  timeRange: {
    timeRangeStart: {
      hours: 0,
      minutes: 0,
      sliderValue: 0
    },
    timeRangeEnd: {
      hours: 24,
      minutes: 0,
      sliderValue: 1440
    }
  }
};

// const DEFAULT_SERVICE_ID_MAP = { X: '1428', GO: '1437' };

export default function filterReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SELECT_DAY:
      const startOfDay = action.payload.startOf('day');

      return { ...state, selectedDay: startOfDay };

    case SELECT_SERVICE:
      return { ...state, selectedService: action.payload };

    case SELECT_DAY_AND_SERVICE:
      const { day, service } = action.payload;

      return {
        ...state,
        selectedDay: day,
        selectedService: service
      };

    case SET_DURATION:
      return { ...state, durationInMinutes: action.payload };

    case SET_TIME_RANGE:
      return { ...state, timeRange: action.payload };

      // case CUSTOMER_SUBSCRIPTION_SET:
      // case CUSTOMER_SUBSCRIPTION_UPDATED:
      //   // FIXME:  Figure out a better option for this
      //   const customerSubscription = action.payload;

      //   if (customerSubscription.customerPlanName.endsWith('X')) {
      //     return { ...state, selectedServiceId: DEFAULT_SERVICE_ID_MAP.X };
      //   }

      //   return { ...state, selectedServiceId: DEFAULT_SERVICE_ID_MAP.GO };
    case USER_LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/filterReducer.js